export const PONDERATOR_PRECISION = 2;
export function formatPercentage(task, lang, value) {
  task.ponderator = value;
  if (!value.toFixed && !value.replace) {
    return '';
  }
  if (lang === 'en') {
    return (
      value.toFixed(
        Number.isInteger(parseFloat(value)) ? 0 : PONDERATOR_PRECISION
      ) + '%'
    );
  }
  return (
    value
      .toFixed(Number.isInteger(parseFloat(value)) ? 0 : PONDERATOR_PRECISION)
      .replace('.', ',') + '%'
  );
}
